import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { IncomingOutgoingAmlContent, TransactionTypeEnum } from '@ui/src';
import { useAppSelector } from '@store';
import useProblemInternalTransaction from '../hooks/use-internal';

const ProblemInternalTransactionAmlContentHOC = (): React.JSX.Element => {
  const { transactionId } = useParams();

  const { aml } = useAppSelector(
    (state) => state.customersProblemTransactions.incoming,
  );

  const { getInternalAmlAction, isLoadingAml } = useProblemInternalTransaction({
    transactionId,
  });

  useEffect(() => {
    if (!aml && transactionId) {
      getInternalAmlAction();
    }
  }, [getInternalAmlAction, aml, transactionId]);

  return (
    <IncomingOutgoingAmlContent
      isLoading={isLoadingAml}
      aml={aml}
      transactionType={TransactionTypeEnum.INCOMING}
    />
  );
};

export default ProblemInternalTransactionAmlContentHOC;
